import React from 'react';
import { Box, CssBaseline, Drawer, List, ListItem, ListItemText, Toolbar } from '@mui/material';
import { Link, Outlet, useLocation } from 'react-router-dom';
import SyncIcon from '@mui/icons-material/Sync';
import PersonIcon from '@mui/icons-material/Person';
import LayersIcon from '@mui/icons-material/Layers';

const drawerWidth = 240;

function SettingsPage() {
    const location = useLocation();

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <Drawer
                variant="permanent"
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
                }}
            >
                <Toolbar />
                <List>
                    <ListItem button component={Link} to="/settings/profile" selected={location.pathname === '/settings/profile'}>
                        <PersonIcon sx={{ mr: 2 }} />
                        <ListItemText primary="Profile" />
                    </ListItem>
                    <ListItem button component={Link} to="/settings/integrations" selected={location.pathname === '/settings/integrations'}>
                        <LayersIcon sx={{ mr: 2 }} />
                        <ListItemText primary="3rd Party Integrations" />
                    </ListItem>
                    <ListItem button component={Link} to="/settings/synchronization" selected={location.pathname === '/settings/synchronization'}>
                        <SyncIcon sx={{ mr: 2 }} />
                        <ListItemText primary="Synchronization" />
                    </ListItem>
                </List>
            </Drawer>
            <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
                <Toolbar />
                <Outlet />
            </Box>
        </Box>
    );
}

export default SettingsPage;
